export default "__VITE_ASSET__DmjlnFoI__"